import React from 'react'
import styled from 'styled-components';
import { Header, Message, Checkbox } from 'semantic-ui-react'
import { map } from 'lodash'

import { __ } from '~/i18n'

import { CheckoutButtons } from '~/components/checkout'
import { ParcelMachine, SimpleErrors } from '~/components/form'
import ContactSummary from '~/components/contact-summary'
import Link from '~/components/link'


import logic from './logic'
import ShippingMethod from './shipping-method'
import ShippingContactForm from './contact-form'

const ShippingStepContainer = styled.div``;
const ShippingItemsContainer = styled.div`
  padding-top: 16px; 
  padding-bottom: 41px;
`;

const ShippingAddressContainer = styled.div`
  padding-top: 32px;
`;

const BillingAddressCheckbox = styled(Checkbox)`
  margin-bottom: 32px;
`;

const BillingAddressContainer = styled.div`
  margin-bottom: 20px;
`;

@logic
export default class ShippingStep extends React.PureComponent {
  handleContinue = () => {
    const { submit } = this.props.actions;

    submit();
  };

  handleShippingAddressChange = (e, { checked }) => {
    const { setUseBillingAddress } = this.props.actions;

    setUseBillingAddress(checked);
  };

  handleEditBillingAddress = (e) => {
    const { setUseBillingAddress } = this.props.actions;

    e.preventDefault();

    setUseBillingAddress(false);
  };

  showContactForm = () => {
    const { currentShippingMethod } = this.props;
    return !!currentShippingMethod;
  };

  render() {
    const {
      onBack,
      loading,
      shippingMethods,
      activeCart,
      useBillingAddress,
      currentShippingMethod,
      billingContact,
      shippingContact,
      pricesLoaded,
      shippingMethodOptions,
      shippingMethodErrors
    } = this.props;
    const { chooseShippingMethod, setShippingMethodOptions, setShippingMethodErrors } = this.props.actions;
    let shippingSettings, contactForm;

    if(currentShippingMethod) {
      if(currentShippingMethod.type === 'ShopSmartPostParcelMethod') {
        shippingSettings = (
          <ParcelMachine
            method={ currentShippingMethod }
            setOptions={ setShippingMethodOptions }
            error={ shippingMethodErrors && shippingMethodErrors.length > 0 }
          />
        );
      } else if (currentShippingMethod.type === 'ShopOmnivaParcelMethod') {
        shippingSettings = (
          <ParcelMachine
            method={ currentShippingMethod }
            placeFormatter={ ParcelMachine.OmnivaPlaceFormatter }
            setOptions={ setShippingMethodOptions }
            error={ shippingMethodErrors && shippingMethodErrors.length > 0 }
          />
        )
      } else if (currentShippingMethod.type === 'ShopDPDParcelMethod') {
        shippingSettings = (
          <ParcelMachine
            method={ currentShippingMethod }
            placeFormatter={ ParcelMachine.DPDPlaceFormatter }
            setOptions={ setShippingMethodOptions }
            error={ shippingMethodErrors && shippingMethodErrors.length > 0 }
          />
        )
      }
    }

    const shippingItems = map(shippingMethods, (shippingMethod) => {
      const active = currentShippingMethod && (shippingMethod.method.url === currentShippingMethod.url);

      return (
        <ShippingMethod
          key={ shippingMethod.method.id }
          shippingMethod={ shippingMethod.method }
          price={ shippingMethod.price }
          selectMethod={ chooseShippingMethod }
          active={ active }
          activeCart={ activeCart }
          name={ shippingMethod.method.name }
          instructions={ shippingMethod.method.instructions }
          shippingSettings={ shippingSettings }
        />
      )
    });

    return (
      <ShippingStepContainer>
        <Header size='large'>{ __("Shipping method") }</Header>
        <Header.Subheader>{ __("Choose a shipping method.") }</Header.Subheader>
        <ShippingItemsContainer>
          { shippingItems }
          {
            pricesLoaded && shippingMethods && shippingMethods.length === 0 ?
              <Message error>
                { __("There are no shipping methods available for chosen items. Please contact the store administrator.") }
              </Message>
              : null
          }
          { shippingMethodErrors && shippingMethodErrors.length > 0 ? <SimpleErrors errors={ shippingMethodErrors } /> : null }
        </ShippingItemsContainer>
        <Header size='large'>{ __("Shipping address") }</Header>
        <Header.Subheader>{ __("Specify if the shipping address is different from the billing address.") }</Header.Subheader>
        <ShippingAddressContainer>
          <BillingAddressCheckbox label={ __('Use Billing Address') } checked={ useBillingAddress } onChange={this.handleShippingAddressChange} />
          {
            useBillingAddress ?
              <BillingAddressContainer>
                <ContactSummary contact={ billingContact }/>
                <Link href="#" onClick={this.handleEditBillingAddress}>{ __('Edit') }</Link>
              </BillingAddressContainer>
            : null
          }
          { this.showContactForm() ? (
            <ShippingContactForm
              shippingMethod={ currentShippingMethod }
              useBillingAddress={ useBillingAddress }
              billingContact={ billingContact }
              shippingMethodOptions={ shippingMethodOptions }
              setShippingMethodErrors={ setShippingMethodErrors }
              shippingContact={ shippingContact }
            />
            )
          : null }
        </ShippingAddressContainer>
        <CheckoutButtons
          onBack={ onBack }
          onContinue={ this.handleContinue }
          loading={ loading }
          continueDisabled={ !currentShippingMethod }
        />
      </ShippingStepContainer>
    )
  }
}
